import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lkf-cookie-bar--background"
}
const _hoisted_2 = { class: "lkf-cookie-bar max--width" }
const _hoisted_3 = { class: "lkf-cookie-bar__content" }
const _hoisted_4 = { class: "lkf-cookie-bar__title" }
const _hoisted_5 = { class: "lkf-cookie-bar__intro" }
const _hoisted_6 = { class: "lkf-cookie-bar__data_title" }
const _hoisted_7 = { class: "lkf-cookie-bar__buttons" }

import { useI18n } from 'vue-i18n';
import { Ref, ref } from 'vue';
import Cookies from 'js-cookie';
import useBodyOverflow from '@/util/useHooks/useBodyOverflow';
import LKFButton from '@/components/LKFButton.vue';
import DataProtection from '@/components/DataProtection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LKFCookiebar',
  setup(__props) {

const { t } = useI18n();
const {
  hideOverflow,
  showOverflow,
} = useBodyOverflow();
let shouldShow = false;

if (typeof Cookies.get('GDPR-consent') === 'undefined') shouldShow = true;
const isPopupDisplayed: Ref<boolean> = ref(shouldShow);
const isDataProtectionOpen = ref(false);

if (isPopupDisplayed.value) {
  hideOverflow();
}

const closeCookieBar = () => {
  isPopupDisplayed.value = false;
  showOverflow();
};

const acceptCookies = () => {
  Cookies.set('GDPR-consent', '1', { expires: 365 });
  closeCookieBar();
};

const rejectCookies = () => {
  Cookies.set('GDPR-consent', '0');
  closeCookieBar();
};


return (_ctx: any,_cache: any) => {
  return (isPopupDisplayed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('cookie-bar.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('cookie-bar.content')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(LKFButton, {
                variant: "ghost",
                class: "lkf-cookie-bar__data-protection-button",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isDataProtectionOpen.value = true), ["prevent","stop"]))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)('cookie-bar.data-protection-title')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(LKFButton, {
                class: "lkf-cookie-bar__buttons--agree",
                variant: "secondary",
                onClick: acceptCookies
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('cookie-bar.agree')), 1)
                ]),
                _: 1
              }),
              _createVNode(LKFButton, {
                class: "lkf-cookie-bar__buttons--disagree",
                onClick: rejectCookies
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('cookie-bar.disagree')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(DataProtection, {
          "is-open": isDataProtectionOpen.value,
          onModalClose: _cache[1] || (_cache[1] = ($event: any) => (isDataProtectionOpen.value=false))
        }, null, 8, ["is-open"])
      ]))
    : _createCommentVNode("", true)
}
}

})